import { PaymentMethodType } from "@app/core/shared/domain/payment-method-type";

export class PaymentMethodWSMapper {
  private static readonly MAPPER_TYPE: Record<PaymentMethodType, string> = {
    [PaymentMethodType.CARD]: "CARD",
    [PaymentMethodType.WALLET]: "WALLET",
  };

  deserialize(paymentMethodType: PaymentMethodType): string {
    return PaymentMethodWSMapper.MAPPER_TYPE[paymentMethodType];
  }
}
